// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: true,
    hmr       : false,
    version   : '10.1.0',
    analyticsID: '',

    ws_url: 'https://ermesprottms.3punto6.com',
    ws_path: '/wss',
    ws_port: null,

    api_url: 'https://ermesprottms.3punto6.com',
    api_port: null,
    api_suffix: '/api',

    videoChat_room_suffix: 'Ens_',
    videoChat_server_url: null,
    videoChat_service_url:  'https://whereby.com/comunicaens_op',

    // redirect url after logout
    return_url: '',

    //App Title
    APP_TITLE: "",

    //App active service
    active_service: ["VIDEOCHAT"],

    navbar_color: "",

    
    showExtraMenu: false,
    showSingUp: false,
    welcomePhrase: "",
    logoProductUrl: "/assets/images/logos/logoecute.svg",
    platform: "amazon_webapp",
    openTicketWithoutModal: true,
    defaultTicketCategory: null,
    domain: "amazonlis.e-cute.it",
    timeToWarning: 900000,
    systemMailTicketScheduled: "support@3punto6.com",
    timeHoursBeforeDeletion: 24,
    embeddedWhereby: true,
    minHoursForTicketSchedulation: 0,
    showRemoteOptionForTicketSchedulation: false,
    platform_id: 1,
    closeNewsModalAutomatically: true
};
